module.exports = __webpack_public_path__ + "b89ca69ca916cb1e7b0aeb82c851445d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-23.png
// module id = 1059
// module chunks = 0